module.exports = __webpack_public_path__ + "static/media/whatsapp.ccca6df2.svg";